import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Select } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';
import { getOuterApiConfigs } from 'src/api/outerApiConfigs';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps extends SelectProps<number> {}

const Template: FC<TemplateProps> = memo((props) => {
    const { ...restProps } = props;

    const [interfaceOptions, setInterfaceOptions] = useState<{ label: string; value: number }[]>(
        []
    );

    const { run } = useRequest(
        (keyword?: string) =>
            getOuterApiConfigs({
                params: {
                    pageNum: 1,
                    pageSize: 1000,
                    keyword,
                },
            }),
        {
            onSuccess: (res) => {
                setInterfaceOptions(
                    (res.data || []).map((item) => {
                        return {
                            label: item.apiName!,
                            value: item.id!,
                        };
                    })
                );
            },
        }
    );

    const onSearch = (v: string) => {
        run(v);
    };

    return (
        <Select
            options={interfaceOptions}
            placeholder={/* 请选择外部接口 */UdeskLocales['current'].components.outerApiConfigsSelect.index.pleaseSelectExternalInterface}
            showSearch
            onSearch={onSearch}
            {...restProps}
        />
    );
});

export default Template;
